module.exports = __webpack_public_path__ + "img/58.1a2cce59.jpg";